/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/destructuring-assignment */
import ArrowDownIcon from "@Icons/ArrowDownIcon";
import { memo, useState } from "react";
import styles from "./CustomAccordianItem.module.scss";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import replaceAmberDomainInLinks from "@Utils/clientUtils/dangerouslySetInnerHtmlUtility/replaceAmberDomainInLinks";
//

const CustomAccordionItem = (props: any) => {
  const { installments, title, description, planType, duration, duration_unit } = props;
  const data = {
    installments,
    title,
    description,
    planType,
    duration,
    duration_unit,
    notes: props.notes,
  };
  const [isOpen, setIsOpen] = useState(props.index === 0);
  const [showAllInstallments, setShowAllInstallments] = useState(false);

  const onClick = () => {
    setIsOpen((p) => !p);
  };

  const toggleInstallmentsView = () => {
    setShowAllInstallments((prev) => !prev);
  };

  const displayedInstallments =
    showAllInstallments || data.installments.length < 10
      ? data.installments
      : data.installments.slice(0, 4);

  const AccordianItem = () => {
    const { t } = useTranslationHook();
    return (
      <div className={styles.accordionWrapper}>
        <div className={styles.accordionItem} onClick={onClick} role="none">
          <div className={styles.headerContent}>
            <h3 className={styles.title}>{data?.title || ""}</h3>
            <p className={styles.description}>
              {data?.duration ? `${data.duration} ${t(data.duration_unit)} • ` : ""}
              {data?.description || ""}
            </p>
          </div>
          <div className={styles.icon}>
            <ArrowDownIcon className={isOpen ? styles.open : ""} />
          </div>
        </div>
        {isOpen && (
          <div className={styles.dropdownContent}>
            {displayedInstallments.map((installment: any, index: number) => (
              <div key={index} className={styles.installmentRow}>
                <div className={styles.innerContainer}>
                  <div className={styles.subHeading}>
                    {t("propertypage.components.installmentsection.customaccordionitem.rent")}
                  </div>
                  <div className={styles.installmentNumber}>
                    {data.planType === "fixed"
                      ? `${t(
                          "propertypage.components.installmentsection.customaccordionitem.installment",
                        )} ${installment?.number}`
                      : installment.number}
                  </div>
                </div>
                <div className={styles.innerContainer}>
                  <div className={styles.subHeading}>
                    {data.planType === "fixed"
                      ? t(
                          "propertypage.components.installmentsection.customaccordionitem.paybefore",
                        )
                      : t("propertypage.components.installmentsection.customaccordionitem.pay")}
                  </div>
                  <div className={styles.date}>{installment.payBefore}</div>
                </div>
                <div className={styles.innerContainer}>
                  <div className={styles.subHeading}>
                    {t("propertypage.components.installmentsection.customaccordionitem.amountdue")}
                  </div>
                  <div className={styles.amount}>{installment.amountDue}</div>
                </div>
              </div>
            ))}
            {data.installments.length >= 10 && (
              <div
                className={styles.viewMoreLink}
                onClick={toggleInstallmentsView}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    toggleInstallmentsView();
                  }
                }}
                role="button"
                tabIndex={0}
              >
                <div className={styles.viewMoreText}>
                  {showAllInstallments
                    ? t(
                        "propertypage.components.installmentsection.customaccordionitem.viewlessinstallments",
                      )
                    : `${t(
                        "propertypage.components.installmentsection.customaccordionitem.viewallinstallments",
                      )} (${data.installments.length})`}
                  <ArrowDownIcon
                    className={`${styles.viewMoreIcon} ${showAllInstallments ? styles.open : ""}`}
                  />
                </div>
              </div>
            )}
            {data.installments.length >= 10 && <div className={styles.divider} />}
            {props.notes?.note &&
              props.notes.note
                .replace(/<[^>]*>/g, "")
                .replace(/&[^;]+;/g, " ")
                .trim() && (
                <>
                  <div className={styles.noteContainer}>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: replaceAmberDomainInLinks(
                          `<b style="font-weight:600;">${t(
                            "propertypage.components.installmentsection.customaccordionitem.note",
                          )}:</b>${props.notes.note}`,
                        ),
                      }}
                      className={styles.noteText}
                    />
                  </div>
                </>
              )}
          </div>
        )}
      </div>
    );
  };

  return <AccordianItem />;
};

export default wrapperHOC(memo(CustomAccordionItem), {
  componentName: "CustomAccordionItem-InstalmentSection-PropertyPage",
  showForChina: true,
});
